import React, {memo} from "react";
import { commonStyle } from "../styles";
import {
    Icon,
    HStack, 
    Avatar, 
    Heading, 
    VStack, 
    Box, 
    Center,
    Stack,
    Badge,
    Input,
    Image,
    IconButton,
    Pressable,
    Divider,
    HamburgerIcon,
    Progress,
    Menu,
    Text, 
    Flex } from 'native-base';
  import {MdRemoveRedEye, MdModeEdit, MdHistory, MdMoreVert, MdDelete, MdDownload } from 'react-icons/md';
  import {FaCalendarAlt, FaEnvelope, FaAngleDown, FaCalendarTimes, FaCalendarCheck, FaWrench } from 'react-icons/fa';
  import moment from "moment";
  import BadgeStatus from "./BadgeStatus";
  import helper from "../util/helper";
  import history from "../util/history";

const CardUnitAnnounceList = (props) => {
  const {data, access, onDelete} = props;

  const handleDownloadBA = () => {
    if(data.pathBA){
      window.open(data.pathBA, '_blank');
    } else {
      helper.infoToast('File belum tersedia');
    }
  }

  const params = {
    id_pengumuman_request: data.id_pengumuman_request,
    id_pengumuman: data.id_pengumuman,
    id_lokasi: data.id_lokasi,
    id_unit:  data.id_unit
  };
  return (
    <Box width="100%" backgroundColor={commonStyle.baseColor} shadow={3} borderRadius="lg">
      <VStack>
        <Box px={5} py={3} backgroundColor={commonStyle.cardBaseHeaderBg} borderTopRadius="lg">
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box>
              <Icon color="darkText" as={<Box><FaCalendarAlt/></Box>} size={5}></Icon>
            </Box>
            <Box flex={1} ml={1}>
              <Text color="darkText" fontWeight={500} >
                {moment(data.tgl_pengumuman, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY HH:mm")}
              </Text>
            </Box>
            <Box ml={3}>
              <BadgeStatus status={data.nm_status}/>
            </Box>
            <Box ml={2} alignItems="center" justifyContent="center" width={8} height={8}>
              <Menu mt={2} py={2} placement="bottom right" trigger={triggerProps => {
                return <Pressable accessibilityLabel="More options menu" {...triggerProps}>
                        <Icon as={<Box><MdMoreVert/></Box>} size={8} color="gray.600" />
                      </Pressable>;
              }}>
                {access.includes('3:VIEW') && 
                <Menu.Item p={1} onPress={() => history.push('unit-announce-form', {...params, viewOnly: true})}>
                  <HStack space={2} justifyContent="center" alignItems="center">
                    <Icon as={<Box><MdRemoveRedEye/></Box>} size="md" color="info.700" />
                    <Text color="darkText" fontSize="md">
                      View
                    </Text>
                  </HStack>
                </Menu.Item>
                }
                {(access.includes('3:EDIT') && data.status_code == '10') && 
                <Menu.Item p={1} onPress={() => history.push('unit-announce-form', {...params, viewOnly: false, new_data: true})}>
                  <HStack space={2} justifyContent="center" alignItems="center">
                    <Icon as={<Box><MdModeEdit/></Box>} size="md" color="info.700" />
                    <Text color="darkText" fontSize="md">
                      Update Pengumuman
                    </Text>
                  </HStack>
                </Menu.Item>
                }
                {(access.includes('3:DEL') && data.status_code == '10' && data.id_pengumuman > 0) && 
                <Menu.Item p={1} onPress={() => onDelete(data.id_pengumuman)}>
                  <HStack space={2} justifyContent="center" alignItems="center">
                    <Icon as={<Box><MdDelete/></Box>} size="md" color="info.700" />
                    <Text color="darkText" fontSize="md">
                      Hapus Pengumuman
                    </Text>
                  </HStack>
                </Menu.Item>
                }
                {(access.includes('3:BA_DOWN') && ['30','40'].includes(data.status_code)) &&
                <Menu.Item p={1} onPress={() => handleDownloadBA()}>
                  <HStack space={2} justifyContent="center" alignItems="center">
                    <Icon as={<Box><MdDownload/></Box>} size="md" color="info.700" />
                    <Text color="darkText" fontSize="md">
                      Download BA
                    </Text>
                  </HStack>
                </Menu.Item>
                }
              </Menu>
            </Box>
          </Stack>
        </Box>
        <Box p={5}>
          <VStack>
            <Flex flexDirection="row" mb={3} alignItems="center">
              <Box width={8} height={8} borderRadius="lg" backgroundColor="primary.400" justifyContent="center">
                <Center>
                  <Icon color="white" as={<Box><FaEnvelope/></Box>} size={5}></Icon>
                </Center>
              </Box>
              <Box ml={2}>
                <Text color="darkText">
                  {data.code_pengumuman}
                </Text>
              </Box>
            </Flex>
            <HStack flex={1} mb={3} space={2}>
              <Box flex={1}>
                <VStack>
                  <Text color="darkText" bold>Tgl Expired</Text>
                  <Text color="darkText">
                    {data.tgl_expired ? moment(data.tgl_expired, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY HH:mm") : '-'}
                  </Text>
                </VStack>
              </Box>
              <Box flex={1}>
                <VStack>
                  <Text color="darkText" bold>Unit / Fakultas</Text>
                  <Text color="darkText">
                    {data.nm_unit}
                  </Text>
                </VStack>
              </Box>
            </HStack>
            <Box flex={1} mb={3}>
              <VStack>
                <Text color="darkText" bold>Catatan</Text>
                <Text color="darkText">
                  {data.catatan}
                </Text>
              </VStack>
            </Box>
            <Flex flexDirection="row" mb={3}>
              <Box>
                <Center>
                  <Avatar size="md" bg="primary.900" mr="1">
                      {helper.getInitials(data.nm_pegawai)}
                  </Avatar>
                </Center>
              </Box>
              <VStack width="90%">
                <Text ml={3} fontSize="lg" color={commonStyle.primaryColor} isTruncated width="80%" fontWeight="bold">
                  {data.nm_pegawai}
                </Text>
                <Text ml={3} fontSize="sm" color="muted.500" isTruncated width="80%">
                  {data.hp_pegawai}
                </Text>
              </VStack>
            </Flex>
            
          </VStack>
        </Box>
      </VStack>
  </Box>
  );
}

export default memo(CardUnitAnnounceList);